import { WebViewBridgeV1 } from './services/WebViewBridgeV1';
import { WebViewBridgeV2 } from './services/WebViewBridgeV2';
export class WebViewBridgeService {
  constructor() {
    throw new Error('Cannot instantiate this class. Use WebViewBridge.getInstance() instead');
  }
  /**
   * Get singleton instance of the WebViewBridgeService
   *
   * @returns {WebViewBridge}
   */
  static getInstance() {
    var _a, _b;
    if (!WebViewBridgeService.instance) {
      if ((_b = (_a = window === null || window === void 0 ? void 0 : window.ReactNativeWebView) === null || _a === void 0 ? void 0 : _a.injectedObjectJson) === null || _b === void 0 ? void 0 : _b.call(_a)) {
        WebViewBridgeService.instance = new WebViewBridgeV1();
      } else {
        WebViewBridgeService.instance = new WebViewBridgeV2();
      }
    }
    return WebViewBridgeService.instance;
  }
  static getMockInstance() {
    return {
      appInfo: undefined,
      securityHeader: undefined,
      isBridgeAvailable: () => false,
      initiateAuth: () => Promise.resolve(false),
      initiateRequestToken: () => Promise.resolve(false),
      initiateOpenPDP: () => Promise.resolve(false),
      initiateOpenMapApp: () => Promise.resolve(false),
      initiateOpenFAQInApp: () => Promise.resolve(false),
      notifyIntentToOpenBottomSheet: () => Promise.resolve(false),
      notifyIntentToCloseBottomSheet: () => Promise.resolve(false),
      notifyIntentToShowOverlay: () => Promise.resolve(false),
      notifyIntentToHideOverlay: () => Promise.resolve(false),
      notifyIntentToLogout: () => Promise.resolve(false),
      notifyIntentToAddToCalendar: () => Promise.resolve(false),
      notifyIntentToOpenWhatsapp: () => Promise.resolve(false),
      notifyIntentToNavigateTo: () => Promise.resolve(false),
      notifyCheckinCompleted: () => Promise.resolve(false),
      notifyBookingCompleted: () => Promise.resolve(false),
      notifyIntentToOpenInAppBrowser: () => Promise.resolve(false),
      sendCheckoutPageParams: () => Promise.resolve(false),
      openUrlInBrowser: () => Promise.resolve(false),
      preventNavigateBack: () => Promise.resolve(false)
    };
  }
}